module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dof-board weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.title || _vm.subtitle) ? _c('div', {
    staticClass: "dof-board-header weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.title) ? _c('p', {
    staticClass: "dof-board-header-title weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.subtitle) ? _c('p', {
    staticClass: "dof-board-header-subtitle weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._t("header", null, {}), _vm._v(" "), _c('div', {
    staticClass: " weex-ct weex-div",
    style: (_vm._px2rem(_vm._boardBodyStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("default", null, {})], 2)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e4ffb9be", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4ffb9be","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-board/index.vue
// module id = 663
// module chunks = 0 1